<div *ngIf="displayMrt">
  <p-dialog header="Предварительный просмотр" #d [(visible)]="displayPreview"
    (onShow)="selectPreview(displayObj, displayMrt, d)" (onHide)="hidePreview()" [contentStyle]="{ overflow: 'scroll' }"
    [style]="{ width: '100vh', 'min-height': '250px', 'max-height': 'calc(100vh - 46px)' }" [positionTop]="0"
    [responsive]="false" [breakpoint]="640" [draggable]="false" [modal]="true" [blockScroll]="true" appendTo="body">
    <div id="page_inner"></div>
  </p-dialog>
</div>